import {
  type UserDocumentPosition,
  type UserDocumentPositionERx,
} from '@redteclab/api/clients/composition-service-account'

export const userSubOrderAccessorIsProductErx = (
  product: UserDocumentPosition | UserDocumentPositionERx,
): product is UserDocumentPositionERx => 'medicationType' in product
